var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3067 58.8168C55.1758 58.8168 59.1229 54.8696 59.1229 50.0006C59.1229 45.1315 55.1758 41.1843 50.3067 41.1843C45.4376 41.1843 41.4905 45.1315 41.4905 50.0006C41.4905 54.8696 45.4376 58.8168 50.3067 58.8168Z",
    fill: "#61DAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3066 68.063C76.4333 68.063 97.6132 59.9762 97.6132 50.0005C97.6132 40.0249 76.4333 31.938 50.3066 31.938C24.1799 31.938 3 40.0249 3 50.0005C3 59.9762 24.1799 68.063 50.3066 68.063Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.664 59.0317C47.7274 81.6582 65.3207 95.957 73.9599 90.9692C82.5991 85.9814 79.0126 63.5956 65.9492 40.9692C52.8858 18.3428 35.2925 4.04392 26.6533 9.03175C18.0141 14.0196 21.6006 36.4053 34.664 59.0317Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.664 40.9692C21.6007 63.5956 18.0141 85.9814 26.6533 90.9692C35.2925 95.957 52.8859 81.6581 65.9492 59.0317C79.0126 36.4053 82.5991 14.0196 73.9599 9.03172C65.3208 4.04389 47.7274 18.3428 34.664 40.9692Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/reactjs.10cb4ee28b543046def58e0b574d8997.svg";
export { ForwardRef as ReactComponent };